import { GetRemoteStringFunction } from '@acorns/web-utils'

import { AllChatHistoryMessagesQuery } from 'generated/types'

import { CHAT_HISTORY_MESSAGE_TYPES } from './constants'
import { buildDateDivider, getDateKey } from './dateUtils'
import { MessageFooterWidgets, extractWidgets } from './extractWidgets'
import { Message } from './types'

export const processChatHistoryMessages = ({
  response,
  getRemoteString,
}: {
  response: AllChatHistoryMessagesQuery
  getRemoteString: GetRemoteStringFunction
}) => {
  const messages = response.allChatHistoryMessages.edges

  const messageMap: Record<string, Message> = {}
  let mostRecentMessageDateKey = ''

  for (const message of messages) {
    const node = message.node
    const dateKey = getDateKey(node.createdAt)

    if (!messageMap[dateKey]) {
      messageMap[dateKey] = buildDateDivider(node.createdAt, getRemoteString)
    }

    if (
      !mostRecentMessageDateKey ||
      new Date(dateKey).getTime() > new Date(mostRecentMessageDateKey).getTime()
    ) {
      mostRecentMessageDateKey = dateKey
    }

    const { citations, deeplinks, customerSupportChatWidgets, chatChoices } =
      extractWidgets(node.chatWidgets as Array<MessageFooterWidgets>)

    messageMap[node.id] = {
      messageType:
        node.author === CHAT_HISTORY_MESSAGE_TYPES.BOT
          ? 'ResponseMessage'
          : 'SentMessage',
      id: node.id,
      text: node.body,
      createdAt: node.createdAt,
      canRate: node.canRate,
      customerSupportChatWidgets,
      deeplinks,
      citations,
      chatChoices,
    }
  }

  const messageOrder = Object.values(messageMap)
    .sort((a, b) => {
      const dateA = new Date(a.createdAt)
      const dateB = new Date(b.createdAt)
      return dateB.getTime() - dateA.getTime()
    })
    .map((message) => message.id)

  return {
    messageMap,
    messageOrder,
    mostRecentMessageDateKey,
  }
}
